// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PublicIndexRouteImport } from './routes/_public.index'
import { Route as PublicLegalRouteImport } from './routes/_public.legal'
import { Route as AuthSignInSplatRouteImport } from './routes/_auth.sign-in.$'
import { Route as AuthSignUpSplatRouteImport } from './routes/_auth.sign-up.$'
import { Route as PublicHelpIndexRouteImport } from './routes/_public.help.index'
import { Route as PublicHelpSlugRouteImport } from './routes/_public.help.$slug'
import { Route as PublicHelpGuidesSlugRouteImport } from './routes/_public.help.guides.$slug'

const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicLegalRoute = PublicLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => PublicRoute
          })
const AuthSignInSplatRoute = AuthSignInSplatRouteImport.update({
            id: '/sign-in/$',path: '/sign-in/$',getParentRoute: () => AuthRoute
          })
const AuthSignUpSplatRoute = AuthSignUpSplatRouteImport.update({
            id: '/sign-up/$',path: '/sign-up/$',getParentRoute: () => AuthRoute
          })
const PublicHelpIndexRoute = PublicHelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => PublicRoute
          })
const PublicHelpSlugRoute = PublicHelpSlugRouteImport.update({
            id: '/help/$slug',path: '/help/$slug',getParentRoute: () => PublicRoute
          })
const PublicHelpGuidesSlugRoute = PublicHelpGuidesSlugRouteImport.update({
            id: '/help/guides/$slug',path: '/help/guides/$slug',getParentRoute: () => PublicRoute
          })





const AuthRouteChildren = {
  AuthSignInSplatRoute: AuthSignInSplatRoute,AuthSignUpSplatRoute: AuthSignUpSplatRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const PublicRouteChildren = {
  PublicLegalRoute: PublicLegalRoute,PublicIndexRoute: PublicIndexRoute,PublicHelpSlugRoute: PublicHelpSlugRoute,PublicHelpIndexRoute: PublicHelpIndexRoute,PublicHelpGuidesSlugRoute: PublicHelpGuidesSlugRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,PublicRoute: PublicRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)